import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withAsyncActions } from 'react-async-client';

import {
    setApprovalProjectListSort,
    setApprovalProjectListPagination,
    setApprovalProjectListSelected
} from 'actions/approvalProjectActions';
import { approvalProject } from 'constants/routes';
import { openModalApproveProject, openModalRejectProject } from 'actions/modalActions';
import { getStatusPayload } from 'helpers/filterHelpers';
import ApprovalList from 'components/common/ApprovalList';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { fullAutoOptions } from 'constants/asyncClient';
import { notificationInterval } from 'constants/defaults';
import { defaultApprovalProjectColumns } from 'constants/defaultColumns';
import { approvalProjectSortFields } from 'constants/defaultSorts';
import getApprovalProjectTableTemplate from './cellTemplates/approvalProjectTableTemplates';
import { getApprovalProjectList, getApprovalProjectCounters } from 'actions/asyncActions';

const tableConfig = {
    defaultColumns: defaultApprovalProjectColumns,
    getTemplate: getApprovalProjectTableTemplate,
    headerTranslatePrefix: 'approvalProject.headers.',
    showTableLabel: true
};

const dispatchToProps = {
    openModalApprove: openModalApproveProject,
    openModalReject: openModalRejectProject,

    setPagination: setApprovalProjectListPagination,
    setSort: setApprovalProjectListSort,
    setSelected: setApprovalProjectListSelected
};

@connect(({ table: { approvalProject } }) => approvalProject, dispatchToProps)
@withAsyncActions({
    getCounters: getApprovalProjectCounters,
    getList: getApprovalProjectList
        .withPayload(getStatusPayload)
        .withOptions({ ...fullAutoOptions, pollInterval: notificationInterval })
})
@withRouteOptions
export default class ApprovalProjectListView extends Component {
    static routeOptions = {
        title: 'menu.approvalProject'
    }

    render() {
        const { approvalProjectList, getList: { data, meta } } = this.props;

        return (
            <ApprovalList
                sortFields={approvalProjectSortFields}
                route={approvalProject}

                meta={meta}
                items={data.project || []}

                tableConfig={tableConfig}

                {...approvalProjectList}
                {...this.props}
            />
        );
    }
}
